let preventAction = false;

function setPreventState(bool) {
  preventAction = bool;
}

export { preventAction, setPreventState };
